<template>
  <div class="payList">
    <div class="list">
      <div class="item" v-for="(item,index) in list" :key="index">
        <div class="top">
          <div class="order_time">订单时间：{{item.time}}</div>
          <div class="pay_btn" @click="handleClickPay(item.id)">付款</div>
        </div>
        <div class="center" @click="item.goods.length>2?item.openup = !item.openup:''">
          <div class="goods" :style="item.openup?('max-height:'+item.goods.length*0.5+'rem'):''">
            <div class="good_item" v-for="(g_item,g_index) in item.goods" :key="g_index">
              <span>{{g_item.name}}</span>
              <span>￥{{g_item.amount}}</span>
            </div>
          </div>
          <img class="jiantou" :openup="item.openup" v-if="item.goods.length>2" src="./../assets/img/up.png" alt="" />
        </div>
        <div class="bottom">
          <div>总计：</div>
          <div>￥{{item.total}}</div>
        </div>
      </div>
    </div>
    <!-- tool -->
    <div class="tool">
      <div class="tip">
        操作流程
      </div>
      <div class="step">
        <div>
          <img src="./../assets/img/tool_1.png" alt="" />
          <span>查找订单</span>
        </div>
        <img class="jiantou" src="./../assets/img/up.png" alt="" />
        <div>
          <img src="./../assets/img/tool_2.png" alt="" />
          <span>点击付款</span>
        </div>
        <img class="jiantou" src="./../assets/img/up.png" alt="" />
        <div>
          <img src="./../assets/img/tool_3.png" alt="" />
          <span>输入密码</span>
        </div>
        <img class="jiantou" src="./../assets/img/up.png" alt="" />
        <div>
          <img src="./../assets/img/tool_4.png" alt="" />
          <span>付款完成</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "payList",
  data() {
    return {
      list: [
        {
          id:'1',
          time:'2020-11-26 15:51',
          goods:[ { name:'蔬菜1',amount:'1.99'},
                  { name:'蔬菜4',amount:'1.99'},
          ],
          total:'4.81',
          openup:false
        },
        {
          id:'2',
          time:'2020-11-26 15:51',
          goods:[ { name:'蔬菜1',amount:'1.99'},
                  { name:'蔬菜2',amount:'1.99'},
                  { name:'蔬菜3',amount:'1.99'},
                  { name:'蔬菜4',amount:'1.99'},
          ],
          total:'4.82',
          openup:false
        },
        {
          id:'3',
          time:'2020-11-26 15:51',
          goods:[ { name:'蔬菜1',amount:'1.99'},
          ],
          total:'4.83',
          openup:false
        },
        {
          id:'5',
          time:'2020-11-26 15:51',
          goods:[ { name:'蔬菜1',amount:'1.99'},
                  { name:'蔬菜2',amount:'1.99'},
                  { name:'蔬菜3',amount:'1.99'},
                  { name:'蔬菜4',amount:'1.99'},
          ],
          total:'4.82',
          openup:false
        },
        {
          id:'665',
          time:'2020-11-26 15:51',
          goods:[ { name:'蔬菜1',amount:'1.99'},
                  { name:'蔬菜2',amount:'1.99'},
                  { name:'蔬菜3',amount:'1.99'},
                  { name:'蔬菜4',amount:'1.99'},
          ],
          total:'4.82',
          openup:false
        },
      ],
    };
  },
  created() {},
  mounted() {},
  methods: {
    // 点击了付款
    handleClickPay(id){
      alert('点击了'+id+'的付款')
    }
  },
};
</script>

<style lang="less" scoped>
.payList {
  position: relative;
  font-size: 0.28rem;
  background-color: #f5f5f5;
  min-height: 100vh;
  .list {
    position: relative;
    padding: 0.3rem 0.3rem 3rem;
    overflow:auto;
    .item {
      width: 100%;
      background-color: #fff;
      border-radius: 0.1rem;
      margin-bottom: 0.3rem;
      .top {
        padding: 0 0.2rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.26rem;
        color: #999;
        height: 0.7rem;
        // border-bottom: 0.01rem solid #e6e6e6;
        box-shadow: 0px 0.01rem 0px 0px #e6e6e6;
        .pay_btn {
          width: 1.1rem;
          height: 0.5rem;
          line-height: 0.5rem;
          background-color: #259c8a;
          border-radius: 0.04rem;
          text-align: center;
          color: #fff;
          font-weight: bold;
        }
      }
      .center {
        padding: 0 0.2rem;
        position: relative;
        .goods {
          margin: 0.2rem 0;
          max-height: 1rem;
          transition:0.2s all ;
          overflow: hidden;
          .good_item {
            height: 0.5rem;
            line-height: 0.5rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-weight: bold;
            font-size: 0.3rem;
          }
        }
        .jiantou {
          position: absolute;
          bottom: 0.4rem;
          left: 50%;
          z-index: 3;
          margin-left: -0.1rem;
          width: 0.2rem;
          height: 0.2rem;
          transition: 0.3s all;
          &[openup]{
            transform: rotateZ(-180deg);
          }
        }
      }

      .bottom {
        padding: 0 0.2rem;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-size: 0.26rem;
        color: #333333;
        height: 0.7rem;
        box-shadow: 0px -0.01rem 0px 0px #e6e6e6;
        div:nth-child(2) {
          font-size: 0.32rem;
          color: #259c8a;
          font-weight: bold;
        }
      }
    }
  }
  .tool{
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 888;
    width: 100%;
    height: 2.7rem;
    box-shadow: 0 0 0.1rem 0.04rem #eee;
    background-color: #fff;
    .tip{
      font-size: 0.28rem;
      color: #999;
      text-align: center;
      margin: 0.25rem 0;
    }
    .step{
      padding: 0 0.3rem;
      display: flex;
      align-items: center;
      justify-content: space-around;
      &>div{
        font-size: 0.26rem;
        color: #999;
        img{
          display: block;
          width: 1rem ;
          height: 1rem ;
          margin-bottom: 0.15rem;
        }
      }
      &>img{
        width: 0.2rem;
        height: 0.2rem;
        margin-bottom: 0.5rem;
        transform: rotateZ(-90deg);
      }
    }
  }
}
</style>